import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import ClientProfileDropdownService from "../../../services/client/ClientProfileDropdownService";
import { loadingClientProfileDropdown } from "../../../store/slices/clientProfiles/clientProfileDropdownSlice";

export const useClientProfileDropdown = () => {
  const dispatch: AppDispatch = useDispatch();

  const { clientProfileDropdown } = useSelector(
    (state: RootState) => state.clientProfileDropdown
  );

  const fetchClientProfileDropdown = async () => {
    try {
      const response = await ClientProfileDropdownService.fetchDropdown();
      // console.log(response);
      dispatch(loadingClientProfileDropdown(response));
    } catch (error) {
      console.error("Error al cargar client profile dropdown:", error);
    }
  };

  return {
    clientProfileDropdown,
    fetchClientProfileDropdown,
  };
};
